import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  LongTextInput,
  EditButton,
  DateField,
  NumberField,
  NumberInput,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
} from 'react-admin';

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const ImageFormatter = v => {
  // console.log("====LogoFormatter=====: ", v);
  if (typeof v === 'object') {
    return v;
  }
  const imageObj = {
    "src": v
  }
  return v
    ? imageObj
    : v;
}

export const ImageParser = v => {
  // console.log("====LogoParser=====: ", v);
  // console.log(v);
  if (typeof v === 'object') {
    return v;
  }

  return v.src
    ? v.src
    : v;
}

export const MCategoryList = (props) => (
  <List {...props} title="List of Category" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="title"/>
      <NumberField source="order"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const MCategoryCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/music-categories">
      <LongTextInput source="title" validate={required()}/>
      <ImageInput source="background_url" label="Background Url" accept="image/*"
                  format={ImageFormatter} parse={ImageParser}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <NumberInput source="background_order"/>
      <NumberInput source="order"/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const MCategoryEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/music-categories">
      <FormTab label="Category Info">
        <LongTextInput source="title" validate={required()}/>
        <ImageInput source="background_url" label="Background Url" accept="image/*"
                    format={ImageFormatter} parse={ImageParser}>
          <ImageField source="src" title="title"/>
        </ImageInput>
        <NumberInput source="background_order"/>
        <NumberInput source="order"/>
      </FormTab>
    </TabbedForm>
  </Edit>
);